// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"8c51be4a","157":"fcaf7eca","163":"b05d9063","488":"52563e0d","501":"fee31d26","845":"88df76a1"}[chunkId] + ".chunk.js";
};